<div class="card-updater-settings">
  <div class="page-title">Card Updater</div>
  <p class="page-description">
    Controle operacional da atualização automática de cartões (Card Updater) nos
    gateways. Desligado por padrão — habilite após confirmação comercial e
    smoke-test em staging. As alterações são aplicadas em tempo real pela
    subscription-api (job Pagar.me) e pelo payment-webhook (webhooks).
  </p>

  <div class="config-list" *ngIf="configs?.length">
    <div class="config-card" *ngFor="let config of configs">
      <div class="config-card__header">
        <div>
          <h3>{{ config.name }}</h3>
          <small>{{ config.configKey }}</small>
        </div>
        <p-inputSwitch
          [ngModel]="config.isEnabled"
          (ngModelChange)="onToggle(config, $event)"
          [disabled]="saving[config.configurationId]"
        />
      </div>
      <p class="config-card__description">{{ config.description }}</p>
      <small *ngIf="config.dateUpdated" class="config-card__updated">
        Última atualização: {{ config.dateUpdated | date: 'dd/MM/yyyy HH:mm' }}
      </small>
    </div>
  </div>
</div>
<p-toast />
